var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnCommonMore = function SvgIcnCommonMore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93356 3.33324C8.93356 3.8487 8.51569 4.26657 8.00023 4.26657C7.48476 4.26657 7.06689 3.8487 7.06689 3.33324C7.06689 2.81777 7.48476 2.3999 8.00023 2.3999C8.51569 2.3999 8.93356 2.81777 8.93356 3.33324ZM8.93356 7.9999C8.93356 8.51537 8.51569 8.93324 8.00023 8.93324C7.48476 8.93324 7.06689 8.51537 7.06689 7.9999C7.06689 7.48444 7.48476 7.06657 8.00023 7.06657C8.51569 7.06657 8.93356 7.48444 8.93356 7.9999ZM8.93356 12.6666C8.93356 13.182 8.51569 13.5999 8.00023 13.5999C7.48476 13.5999 7.06689 13.182 7.06689 12.6666C7.06689 12.1511 7.48476 11.7332 8.00023 11.7332C8.51569 11.7332 8.93356 12.1511 8.93356 12.6666Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnCommonMore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_common_more.ec620b08.svg";
export { ForwardRef as ReactComponent };